module.exports = __webpack_public_path__ + "img/foodtype-italian.2b2f6a77.png";